"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShareWrapper = exports.ShareComponent = void 0;
var share_component_1 = require("./share-component");
Object.defineProperty(exports, "ShareComponent", { enumerable: true, get: function () { return share_component_1.ShareComponent; } });
var share_wrapper_1 = require("./share-wrapper");
Object.defineProperty(exports, "ShareWrapper", { enumerable: true, get: function () { return share_wrapper_1.ShareWrapper; } });
